/**
 * สำเนาตะกร้าและข้อมูลที่ลูกค้ากรอกไว้ ก่อนที่มันจะถูกล้างตอนสร้างการจอง
 *
 * ตะกร้าต้องถูกล้างตอนสร้างการจอง ไม่งั้นกดจองซ้ำจะได้การจองใบที่สองกันห้องซ้อนกัน
 * แต่ถ้าลูกค้าจ่ายไม่ทันหรือเปลี่ยนใจ ข้อมูลที่กรอกมาทั้งหมด (ห้อง วันที่ จำนวนคน
 * อุปกรณ์เสริม ชื่อ เบอร์ ที่อยู่ ข้อมูลภาษี) จะหายไปหมดและต้องกรอกใหม่ตั้งแต่ต้น
 *
 * เก็บไว้ที่นี่เพื่อเอากลับมาให้ตอนที่การจองนั้นจบไปแล้วจริงๆ (ถูกยกเลิกหรือลูกค้ากดยกเลิกเอง)
 * -- ห้ามเอากลับมาระหว่างที่การจองยังมีชีวิตอยู่ เพราะจะกลายเป็นจองซ้อน
 */
const KEY = 'once_cart_snapshot';

export const saveCartSnapshot = (payload) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...payload, savedAt: Date.now() }));
  } catch (e) {
    /* เขียนไม่ได้ก็แค่ไม่มีของกู้คืน ไม่ทำให้การจองพัง */
  }
};

export const getCartSnapshot = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    // เก็บไว้ 6 ชั่วโมง -- นานพอให้กลับมาในวันเดียวกัน แต่ไม่นานจนราคา/ห้องว่างเปลี่ยนไปแล้ว
    if (!data?.cart || Date.now() - (data.savedAt || 0) > 6 * 60 * 60 * 1000) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
};

export const clearCartSnapshot = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) { /* ignore */ }
};
